import { api } from './_client';
import type {
  CreateAnnouncementResponse,
  UserAnnouncementsResponse,
  UnreadCountResponse,
  AdminAnnouncementsResponse,
  MarkReadResponse,
} from '../../types/api';

export const announcementsApi = {
  // Create announcement with attachments (XER admin only)
  async createAnnouncementWithAttachments(
    title: string,
    body: string,
    targetType: 'all_users' | 'organizations' | 'users',
    targetIds: string[],
    files: File[],
    sendEmailNotification: boolean = false
  ): Promise<CreateAnnouncementResponse> {
    const formData = new FormData();
    formData.append('title', title);
    formData.append('body', body);
    formData.append('target_type', targetType);
    formData.append('target_ids', JSON.stringify(targetIds));
    formData.append('send_email_notification', String(sendEmailNotification));

    files.forEach((file) => {
      formData.append('files', file);
    });

    const response = await api.post<CreateAnnouncementResponse>(
      '/api/announcements/with-attachments',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 120000, // 2 minutes for file uploads
      }
    );
    return response.data;
  },

  // Get user's announcements
  async getUserAnnouncements(): Promise<UserAnnouncementsResponse> {
    const response = await api.get<UserAnnouncementsResponse>('/api/announcements');
    return response.data;
  },

  // Get unread count
  async getUnreadAnnouncementCount(): Promise<UnreadCountResponse> {
    const response = await api.get<UnreadCountResponse>('/api/announcements/unread-count');
    return response.data;
  },

  // Mark announcement as read
  async markAnnouncementAsRead(recipientId: string): Promise<MarkReadResponse> {
    const response = await api.post<MarkReadResponse>(
      `/api/announcements/${recipientId}/mark-read`
    );
    return response.data;
  },

  // Get all announcements (XER admin only)
  async getAllAnnouncementsAdmin(): Promise<AdminAnnouncementsResponse> {
    const response = await api.get<AdminAnnouncementsResponse>('/api/announcements/admin/all');
    return response.data;
  },

  // Get fresh download URL for announcement attachment
  async getAnnouncementAttachmentDownloadUrl(
    s3Key: string
  ): Promise<{ url: string; expires_in: number }> {
    const response = await api.get<{ url: string; expires_in: number }>(
      '/api/announcements/attachment-download-url',
      { params: { s3_key: s3Key } }
    );
    return response.data;
  },
};
